import React from "react";
import { Card, CardBody, Row, Col, Table, Button } from "reactstrap";

const AllItems = () => {
  // Dummy item data
  const items = [
    {
      id: 1,
      name: "Diamond Sword",
      image: "https://via.placeholder.com/60",
      amount: 10,
    },
    {
      id: 2,
      name: "Magic Shield",
      image: "https://via.placeholder.com/60",
      amount: 25,
    },
    {
      id: 3,
      name: "Health Potion",
      image: "https://via.placeholder.com/60",
      amount: 5,
    },
    {
      id: 4,
      name: "Golden Armor",
      image: "https://via.placeholder.com/60",
      amount: 100,
    },
  ];

  return (
    <div className="page-content">
      <Card className="mb-4">
        <CardBody>
          <Row className="mb-3">
            <Col md={6}>
              <h4 className="card-title">All Items</h4>
            </Col>
            <Col md={6} className="text-end">
              <Button color="primary">Add Item</Button>
            </Col>
          </Row>

          <div className="table-responsive">
            <Table className="table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item Image</th>
                  <th>Item Name</th>
                  <th>Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={item.image}
                        alt={item.name}
                        className="rounded"
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                        }}
                      />
                    </td>
                    <td>{item.name}</td>
                    <td>${item.amount}</td>
                    <td>
                      <Button color="info" size="sm" className="me-2">
                        Edit
                      </Button>
                      <Button color="danger" size="sm">
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default AllItems;
